export interface ClientNextHistory {
    appId: string;
    appDate: string;
    appReservationCode: string;
    appStart: string;
    append: string;
    appCode: string;
    appDescription: string;
    clinicName: string;
    clinicSelf: string;
    appPackageDescription: string;
    appConfirmed: string;
}

export interface ClientPreviousHistory {
    laserGid: string;
    clientPrescriptions: string;
    clientDelayed: string;
    clientVisit: string;
    clinicName: string;
    laserDate: string;
    appReservationCode: string;
    username: string;
    zone: string;
    zoneDescription: string;
    session: string;
    equipment: string;
    spot: string;
    energy: string;
    mSec: string;
    dcd: string;
    shotInitial: string;
    shotFinal: string;
    time: string;
    serviceDescription: string;
    familyDescription: string;
    comments: string;
    treatment: string;
    hClass: string;
    voucherName: string;
    clientReferer: string;
}

export const createClientNextHistory = (data: any): ClientNextHistory => ({
    appCode: data.appcode,
    appConfirmed: data.appconfirmed,
    appDate: data.appdate,
    appDescription: data.appdesc,
    append: data.append,
    appId: data.appid,
    appPackageDescription: data.apppackdesc,
    appReservationCode: data.reservationcode,
    appStart: data.appstart,
    clinicName: data.clinicname,
    clinicSelf: data.clinicself
});

export const createClientPreviousHistory = (data: any): ClientPreviousHistory => ({
    appReservationCode: data.appreservationcode,
    clientDelayed: data.clientdelayed,
    clientPrescriptions: data.clientprescriptions,
    clientVisit: data.clientvisit,
    clinicName: data.clinicname,
    comments: data.comments,
    dcd: data.dcd,
    energy: data.energy,
    equipment: data.equipment,
    familyDescription: data.familydesc,
    hClass: data.hclass,
    laserDate: data.laserdate,
    laserGid: data.lasergid,
    mSec: data.msec,
    serviceDescription: data.servicedesc,
    session: data.session,
    shotFinal: data.shotfin,
    shotInitial: data.shotini,
    spot: data.spot,
    time: data.time,
    treatment: data.treatment,
    username: data.username,
    zone: data.zone,
    zoneDescription: data.zonedesc,
    voucherName: data.vouchername,
    clientReferer: data.clientreferer
});

export const getMainIconClientPreviousHistory = (data: ClientPreviousHistory): string => {
    let mainIcon = 'checkbox-outline'; // Cita validada
    if (data.clientVisit === '-1') { // Visita
        mainIcon = 'eye-outline';
    } else if (data.clientReferer && data.clientReferer !== '') {
        mainIcon = 'star-outline';
    } else {
        switch (data.hClass) {
            case '0': {
                if (data.voucherName !== '') {
                    mainIcon = 'ticket-outline'; // Cita validada pagada con bono
                }
                break;
            }
            case '1': mainIcon = 'enter-outline'; break; // Cita desplazada
            case '2': mainIcon = 'close-outline'; break; // Cita anulada
            case '3': mainIcon = 'chatbox-ellipses-outline'; break; // Comentario
            case '4': mainIcon = 'basket-outline'; break; // Producto adquirido en un ticket
        }
    }

    return mainIcon;
};

export const getMainDescriptionPreviousHistory = (data: ClientPreviousHistory): string => {
    let mainDescription = data.zoneDescription;

    if (data.clientReferer && data.clientReferer !== '') {
        mainDescription = data.clientReferer;
    }

    return mainDescription;
};

export const isConversion = (data: ClientPreviousHistory): boolean => data.clientReferer && data.clientReferer !== '';
